(() => {
  if (window.CileaPreorderConfirmationLoaded) return;
  window.CileaPreorderConfirmationLoaded = true;

  const PREORDER_SELECTOR = '[data-cilea-preorder]';
  const CHECKBOX_SELECTOR = '[data-cilea-preorder-checkbox]';
  const ERROR_SELECTOR = '[data-cilea-preorder-error]';

  function setupPreorderBlock(block) {
    if (!block || block.dataset.cileaReady === 'true') return;

    block.dataset.cileaReady = 'true';

    const form =
      block.closest('form[data-type="add-to-cart-form"]') ||
      document.getElementById(block.dataset.formId);

    if (!form) return;

    const checkbox = block.querySelector(CHECKBOX_SELECTOR);
    const error = block.querySelector(ERROR_SELECTOR);
    const submitButton = form.querySelector('button[name="add"]');

    if (!checkbox) return;

    /*
     * 受注生産商品の購入ボタン文言を変更。
     * Dawnがバリエーション変更時にボタンを更新しても追従する。
     */
    const updateButtonText = () => {
      if (!submitButton || submitButton.disabled) return;

      const textElement = submitButton.querySelector('span');

      if (
        textElement &&
        textElement.textContent.trim() !== '受注生産で注文する'
      ) {
        textElement.textContent = '受注生産で注文する';
      }
    };

    updateButtonText();

    if (submitButton) {
      const observer = new MutationObserver(() => {
        updateButtonText();
      });

      observer.observe(submitButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        checkbox.removeAttribute('aria-invalid');

        if (error) {
          error.hidden = true;
        }
      }
    });
  }

  function setupPreorderBlocks(root = document) {
    root.querySelectorAll(PREORDER_SELECTOR).forEach((block) => {
      setupPreorderBlock(block);
    });
  }

  /*
   * Dawnの商品フォームが送信される前にチェック。
   * novalidateが設定されていても確実に購入を止める。
   */
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest(
        'form[data-type="add-to-cart-form"]'
      );

      if (!form) return;

      const checkbox = form.querySelector(CHECKBOX_SELECTOR);

      if (!checkbox) return;

      if (!checkbox.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const block = checkbox.closest(PREORDER_SELECTOR);
        const error = block?.querySelector(ERROR_SELECTOR);

        checkbox.setAttribute('aria-invalid', 'true');

        if (error) {
          error.hidden = false;
        }

        checkbox.focus({
          preventScroll: true,
        });

        block?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupPreorderBlocks();
    });
  } else {
    setupPreorderBlocks();
  }

  /*
   * Shopifyテーマエディタでセクションが再読み込みされた場合にも対応。
   */
  document.addEventListener('shopify:section:load', (event) => {
    setupPreorderBlocks(event.target);
  });
})();